import { render, staticRenderFns } from "./ReviewsPatientPreview.vue?vue&type=template&id=69a58a21&scoped=true"
import script from "./ReviewsPatientPreview.vue?vue&type=script&lang=js"
export * from "./ReviewsPatientPreview.vue?vue&type=script&lang=js"
import style0 from "./ReviewsPatientPreview.vue?vue&type=style&index=0&id=69a58a21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a58a21",
  null
  
)

export default component.exports